import { render, staticRenderFns } from "./AdminStreamOwnerPayments.vue?vue&type=template&id=09a0bb1b&"
import script from "./AdminStreamOwnerPayments.vue?vue&type=script&lang=ts&"
export * from "./AdminStreamOwnerPayments.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports